import React, { useEffect, useRef } from 'react'

const SoftButton = ({ 
  label,
  ariaLabel,
  icon = null,
  iconPosition = 'end',
  iconGap = 'gap-x-3',
  onClick,
  className = null,
  color = null,
  defaultSelected=false,
  disabled = false,
 }) => {
  const buttonRef = useRef(null)

  useEffect(() => {
    if(defaultSelected && buttonRef.current)
      buttonRef.current.focus()
  }, [defaultSelected])

  return (
    <button 
        className={`soft-button ${color && 'text-[#' + color + ']'} ${className && className}`}
        onClick={onClick}
        ref={buttonRef}
        disabled={disabled}
        aria-label={ariaLabel}
      >
      <span className={`inline-flex ${iconGap} items-center`}>
        { iconPosition === 'start' && icon }
        { label }
        { iconPosition === 'end' && icon }
      </span>
    </button>
  )
}

export default SoftButton